import React, { useEffect } from 'react';
import { motion, useMotionValue, useSpring } from 'framer-motion';
export function CustomCursor() {
  const cursorX = useMotionValue(-100);
  const cursorY = useMotionValue(-100);
  const springConfig = {
    damping: 30,
    stiffness: 800,
    mass: 0.25
  };
  const x = useSpring(cursorX, springConfig);
  const y = useSpring(cursorY, springConfig);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      cursorX.set(e.clientX);
      cursorY.set(e.clientY);
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, [cursorX, cursorY]);
  return <motion.div className="fixed top-0 left-0 pointer-events-none z-[9999] hidden md:block" style={{
    x,
    y
  }} data-id="element-86">
      {/* Plus sign cursor */}
      <div className="relative -translate-x-1/2 -translate-y-1/2 w-6 h-6" data-id="element-87">
        {/* Horizontal bar */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-5 h-[1.5px] bg-accent rounded-full" data-id="element-88" />
        {/* Vertical bar */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1.5px] h-5 bg-accent rounded-full" data-id="element-89" />
      </div>
    </motion.div>;
}